module.exports = __webpack_public_path__ + "static/scrap_mountain-1d8a087d6e5047279e4fdcead01d7765.png";